import { ONBOARD_CALENDAR_URL } from '../constants/externalResources'

const buildCalendarUrl = (userId) => ONBOARD_CALENDAR_URL + userId

export { buildCalendarUrl }
